import React, { Fragment } from 'react'
import { Typography, Grid, List, ListItem, Divider, ListItemText, ListItemAvatar, ListSubheader } from '@material-ui/core';
import DayCard from './DayCard';
import TimeAtar from './TimeAtar';

const today = new Date().toISOString().substr(0, 10);

const Display = (props) => {

  // for grouping i need to group them... like map by date...

  const todaysSchedule = props.days.filter(day => day.date === today);

  const todaysCards =
    <Grid container spacing={1}>
      {todaysSchedule && todaysSchedule.map((day) => {
        return (
          <DayCard key={day.id} day={day} {...props} />
        )
      })}
    </Grid>

  const groupByDay = (days) => {
    const byDay = new Map();

    // sort by days but first copy
    const sortedDays = [...days];
    sortedDays.sort((a, b) => new Date(a.date) - new Date(b.date));

    for (let entry of sortedDays) {
      // console.log(entry.date);

      // first just count
      if (!byDay.has(entry.date)) {
        // console.log('not here');
        byDay.set(entry.date, [entry]);
      } else {
        byDay.set(entry.date, [...byDay.get(entry.date), entry])
      }
    }

    // now the map has been sorted by days
    return byDay;
  }


  return (
    <React.Fragment>
      <Typography>All cards are being displayed</Typography>
      <List>
        {props.days && Array.from(groupByDay(props.days)).map(([aDay, entries]) => {
          return (
            <React.Fragment key={aDay}>
              <ListSubheader 
                disableSticky
              >
                {aDay}
              </ListSubheader>
              {entries.map((entry, ix, arr) => {
                let notLast = ix !== arr.length - 1;
                return (
                  <React.Fragment key={entry.id}>
                    <ListItem alignItems='flex-start'>
                      <ListItemAvatar>
                        <TimeAtar hours={entry.startTime.substr(0, 2)} minutes={entry.startTime.substr(3, 2)} />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <React.Fragment>
                            {entry.classRoom.substr(0, 1)}<sub>{entry.classRoom.substr(2, 1)}</sub>
                          </React.Fragment>
                        }
                        secondary={entry.entry}
                      />
                    </ListItem>
                    {notLast && <Divider />}
                  </React.Fragment>
                )
              })}
            </React.Fragment>
          )
        })}
      </List>
    </React.Fragment>
  )
}

export default Display
